<template>
  <span v-bind:class="spanClasses">{{ display }}</span>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import { formatDate, formatTime, formatDateTime } from '@/services/date'

// 表示種類
type DisplayType = 'date' | 'time' | 'datetime'

/**
 * 日付表示コンポーネント
 */
export default defineComponent({
  name: 'DateDisplay',
  props: {
    // 日付(文字列)
    date: {
      type: String,
      required: false,
      default: null,
    },
    // 表示の種類
    type: {
      type: String as PropType<DisplayType>,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
  },
  setup(props) {
    const display = computed(() => {
      if (props.date == null || props.date === '') {
        // 日付未指定時は空文字
        return ''
      }

      // 表示の種類に応じてフォーマットした文字列を返す
      if (props.type === 'date') {
        return formatDate(props.date)
      } else if (props.type === 'time') {
        return formatTime(props.date)
      }
      return formatDateTime(props.date)
    })

    const spanClasses = computed(() => {
      if (props.size === 'small') {
        return {
          'text-xs': true,
        }
      } else {
        return {}
      }
    })
    return {
      display,
      spanClasses,
    }
  },
})
</script>
